import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  branch: 0,
};

export const WoBranchSlice = createSlice({
  name: "woBranch",
  initialState,
  reducers: {
    setBranch: (state, action) => {
      state.branch = action.payload;
    },
  },
});

export const { setBranch } = WoBranchSlice.actions;

export default WoBranchSlice.reducer;
